import React from "react";
var __jsx = React.createElement;
import { useIntl } from 'react-intl';
import { useOpenPreview } from 'libs/content/hooks';
import { CTAButton, CTAContainer } from '../common/style';
import { PreviewIcon } from './PreviewButton.style';

var PreviewButton = function PreviewButton(_ref) {
  var publicationStatus = _ref.publicationStatus;
  var intl = useIntl();

  var _useOpenPreview = useOpenPreview(),
      doOpenPreview = _useOpenPreview.doOpenPreview;

  return __jsx(CTAContainer, {
    onClick: function onClick() {
      return doOpenPreview({
        status: publicationStatus
      });
    }
  }, __jsx(CTAButton, {
    "aria-label": intl.formatMessage({
      id: 'content.edit.call-to-actions.preview.label'
    })
  }, __jsx(PreviewIcon, null)));
};

export default PreviewButton;